module.exports = __webpack_public_path__ + "img/turbo_off.12feb995.svg";